import useOperationalAccess from "./hooks/useOperationalAccess";
import React, { useState } from "react";
import { useSelector } from "react-redux";
//Sections
import { Orders } from "./pages/orders";
import { MenuMobile } from "./components/menuMobile";
import { LoaderComponent } from "./components/loaderComponent";
import { Alert } from "./components/alert";
import { MapLocation } from "./pages/orderMap";
import { UserSelect } from "./pages/login/userSelect";
import { OrderDetails } from "./pages/orderDetails";
import { OrdersDelivered } from "./pages/ordersDelivered";
import { OrderResumedMap } from "./pages/orderResumedMap";
import { DeliveryDone } from "./pages/deliveryDone";
import { DeliveryFailed } from "./pages/deliveryFailed";
import { Payment } from "./pages/payment";
import packageJson from "../package.json";
import "./custom.css";
import Initializer from "./hooks/initializer";
import useLogoutSync from "./hooks/useLogoutSync";

function App() {
  useOperationalAccess();
  useLogoutSync();
  const [ready, setReady] = useState(false);
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);
  const componentActive = useSelector((state) => state.aplicationConfig.userConfig.componentActive);

  const Component = () => {
    if (logged && logged) {
      switch (componentActive) {
        case "userSelect":
          return <UserSelect />;
        case "delivery":
          return (
            <>
              <MenuMobile />
              <OrdersDelivered />
            </>
          );
        case "orders":
          return (
            <>
              <MenuMobile />
              <Orders />
            </>
          );
        case "orderMap":
          return (
            <>
              <MenuMobile />
              <MapLocation />
            </>
          );
        case "orderDetails":
          return (
            <>
              <MenuMobile />
              <OrderDetails />
            </>
          );
        case "orderResumedMap":
          return (
            <>
              <MenuMobile />
              <OrderResumedMap />
            </>
          );
        case "payment":
          return (
            <>
              <MenuMobile />
              <Payment />
            </>
          );
        case "deliveryDone":
          return (
            <>
              <MenuMobile />
              <DeliveryDone />
            </>
          );
        case "deliveryFailed":
          return (
            <>
              <MenuMobile />
              <DeliveryFailed />
            </>
          );
        default:
          return <UserSelect />;
      }
    } else return <UserSelect />;
  };

  return (
    <>
      <Initializer onInit={() => setReady(true)} />

      <LoaderComponent />
      {ready ? <Component /> : null}
      <div className="appVersion" style={{ marginBottom: "60px" }}>
        {packageJson.version + "/" + packageJson.dependencies["@delibrandev/utils"].replace("^", "")}
      </div>
      <Alert />
    </>
  );
}

export default App;
